import { createContext, type ReactNode, type RefObject, useContext, useRef } from "react"

interface RefsContextType {
	headerRef: RefObject<HTMLElement>
	footerRef: RefObject<HTMLElement>
	mainRef: RefObject<HTMLElement>
}

const RefsContext = createContext<RefsContextType | undefined>(undefined)

export function RefsProvider({ children }: { children: ReactNode }) {
	const headerRef = useRef<HTMLElement>(null)
	const footerRef = useRef<HTMLElement>(null)
	const mainRef = useRef<HTMLElement>(null)

	return <RefsContext.Provider value={{ headerRef, footerRef, mainRef }}>{children}</RefsContext.Provider>
}

export function useRefsContext() {
	const context = useContext(RefsContext)
	if (context === undefined) {
		throw new Error("useRefsContext must be used within a RefsProvider")
	}
	return context
}
